import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { hasPermission } from '../Protected';
import { Permission } from '../permissions';
import { FeatureFlag } from '../featureFlags';
import { getDomains } from './getDomains';
import { insertActivationPageUrlsWhereNeeded } from './ActivationPages';
import { deepFilterLinks, deepMapLinks } from './linkUtils';
export function getLinks(props) {
  var currentTree = getAllLinks(props);
  currentTree = filterBasedOnPermissionsAndFeatureFlags(currentTree, props.featureFlags || {}, props.context);
  currentTree = removeExtraProps(currentTree);
  var activationPageContext = {
    domains: getDomains(props.environment, props.domains),
    orgId: props.organizationId
  };
  return insertActivationPageUrlsWhereNeeded(currentTree, props.context, activationPageContext);
}
export function getAllLinks(_ref) {
  var organizationId = _ref.organizationId,
      environment = _ref.environment,
      _ref$featureFlags = _ref.featureFlags,
      featureFlags = _ref$featureFlags === void 0 ? {} : _ref$featureFlags,
      domains = _ref.domains;
  var baseUrls = getDomains(environment, domains);
  var orgIdParam = "?swicus_org_id=".concat(organizationId);
  return [{
    key: 'home',
    label: 'Home',
    href: "".concat(baseUrls.common, "/home").concat(orgIdParam),
    icon: 'home'
  }, {
    key: 'synthetics',
    label: 'Synthetics',
    icon: 'arrows-up-down',
    featureFlag: FeatureFlag.PINGDOM_CONVERGED,
    links: [{
      key: 'uptime',
      label: 'Uptime',
      href: "".concat(baseUrls.pingdom, "/app/newchecks/checks").concat(orgIdParam)
    }, {
      key: 'transaction',
      label: 'Transactions',
      href: "".concat(baseUrls.pingdom, "/app/newchecks/transactions").concat(orgIdParam)
    }, {
      key: 'page-speed',
      label: 'Page Speed',
      href: "".concat(baseUrls.pingdom, "/app/3/page-speed-checks").concat(orgIdParam)
    }, {
      key: 'maintenance',
      label: 'Maintenance',
      href: "".concat(baseUrls.pingdom, "/app/3/maintenance").concat(orgIdParam)
    }, {
      key: 'public-status',
      label: 'Public Status Page',
      href: "".concat(baseUrls.pingdom, "/app/reports/public").concat(orgIdParam)
    }, {
      key: 'email-reports',
      label: 'Email Reports',
      href: "".concat(baseUrls.pingdom, "/app/reports/email").concat(orgIdParam)
    }, {
      key: 'report-banners',
      label: 'Report Banners',
      href: "".concat(baseUrls.pingdom, "/app/reports/banner").concat(orgIdParam)
    }, {
      key: 'probe-servers',
      label: 'Probe Servers',
      href: "".concat(baseUrls.pingdom, "/app/probes").concat(orgIdParam)
    }]
  }, {
    key: 'rum',
    label: 'Real User Monitoring',
    href: "".concat(baseUrls.pingdom, "/app/3/visitor-insights").concat(orgIdParam),
    featureFlag: FeatureFlag.PINGDOM_CONVERGED,
    icon: 'transaction'
  }, {
    key: 'services',
    label: 'Services',
    href: "".concat(baseUrls.appoptics, "/apm/services").concat(orgIdParam),
    icon: 'apm-outline'
  }, {
    key: 'infrastructure',
    label: 'Infrastructure',
    icon: 'hosts',
    links: [{
      key: 'hosts',
      label: 'Hosts',
      href: "".concat(baseUrls.appoptics, "/infrastructure/hosts").concat(orgIdParam)
    }, {
      key: 'containers',
      label: 'Containers',
      href: "".concat(baseUrls.appoptics, "/infrastructure/containers").concat(orgIdParam)
    }, {
      key: 'integrations',
      label: 'Integrations',
      href: "".concat(baseUrls.appoptics, "/infrastructure/integrations").concat(orgIdParam)
    }]
  }, {
    key: 'logs',
    label: 'Logs',
    icon: 'search-logs',
    links: [{
      key: 'log-explorer',
      label: 'Log Explorer',
      href: "".concat(baseUrls.logs, "/search").concat(orgIdParam)
    }].concat(_toConsumableArray(isBetaCustomerForLogConfiguration(organizationId) ? [{
      key: 'log-configuration',
      label: 'Log Configuration',
      href: "".concat(baseUrls.common, "/settings/").concat(organizationId, "/logs"),
      permission: Permission.LOG_CONFIGURATION_VISIT,
      newTab: true
    }] : []), [{
      key: 'log-charts',
      label: 'Log Charts',
      href: "".concat(baseUrls.logs, "/charts").concat(orgIdParam)
    }, {
      key: 'derived-fields',
      label: 'Derived Fields',
      href: "".concat(baseUrls.logs, "/parser/manage").concat(orgIdParam)
    }, {
      key: 'source-setup',
      label: 'Source Setup',
      href: "".concat(baseUrls.logs, "/sources/browser").concat(orgIdParam)
    }])
  }, {
    key: 'metrics',
    label: 'Metrics',
    href: "".concat(baseUrls.metrics, "/s/metrics").concat(orgIdParam),
    icon: 'chart-line'
  }, {
    key: 'dashboards',
    label: 'Dashboards',
    href: "".concat(baseUrls.dashboards, "/dashboards/").concat(organizationId),
    icon: 'dashboard'
  }, {
    key: 'alerts',
    label: 'Alerts',
    icon: 'alert',
    links: [{
      key: 'metric-alerts',
      label: 'Metric Alerts',
      href: "".concat(baseUrls.appoptics, "/alerts").concat(orgIdParam)
    }, {
      key: 'log-alerts',
      label: 'Log Alerts',
      href: "".concat(baseUrls.logs, "/alerts").concat(orgIdParam)
    }, {
      key: 'log-alert-endpoints',
      label: 'Log Alert Endpoints',
      href: "".concat(baseUrls.logs, "/alerts/endpoint").concat(orgIdParam)
    }]
  }, {
    key: 'settings',
    label: 'Settings',
    icon: 'settings',
    links: [{
      key: 'org-settings',
      label: 'Organization Settings',
      links: [{
        key: 'general',
        label: 'General',
        href: "".concat(baseUrls.common, "/settings/").concat(organizationId),
        newTab: true
      }, {
        key: 'users',
        label: 'Users',
        href: "".concat(baseUrls.common, "/settings/").concat(organizationId, "/users"),
        newTab: true
      }, {
        key: 'activity-log',
        label: 'Activity Log',
        href: "".concat(baseUrls.common, "/settings/").concat(organizationId, "/activity"),
        permission: Permission.AUDIT_TRAIL_VISIT,
        newTab: true
      }, {
        key: 'api-tokens',
        label: 'API Tokens',
        href: "".concat(baseUrls.common, "/settings/").concat(organizationId, "/activity"),
        featureFlag: FeatureFlag.API_TOKENS,
        permission: Permission.TOKEN_VISIT,
        newTab: true
      }, {
        key: 'security-saml',
        label: 'Security',
        href: "".concat(baseUrls.common, "/settings/").concat(organizationId, "/security"),
        target: '_blank',
        permission: Permission.SECURITY_VISIT,
        newTab: true
      }]
    }, {
      key: 'pingdom-settings',
      label: 'Synthetic & RUM Settings',
      featureFlag: FeatureFlag.PINGDOM_CONVERGED,
      permission: Permission.PINGDOM_VISIT,
      links: [{
        key: 'pingdom-subscription',
        label: 'Subscription',
        href: "".concat(baseUrls.pingdom, "/app/3/account/subscription").concat(orgIdParam)
      }, {
        key: 'pingdom-preferences',
        label: 'Preferences',
        href: "".concat(baseUrls.pingdom, "/app/preferences").concat(orgIdParam)
      }, {
        key: 'alert-recipients',
        label: 'Alert Recipients',
        href: "".concat(baseUrls.pingdom, "/app/3/alert-recipients").concat(orgIdParam)
      }, {
        key: 'pingdom-integrations',
        label: 'Integrations',
        href: "".concat(baseUrls.pingdom, "/app/integrations/settings").concat(orgIdParam)
      }, {
        key: 'pingdom-api',
        label: 'Pingdom API',
        href: "".concat(baseUrls.pingdom, "/app/api-tokens").concat(orgIdParam)
      }]
    }, {
      key: 'metric-settings',
      label: 'Metric Settings',
      permission: Permission.APPOPTICS_VISIT,
      links: [{
        key: 'ao-preferences',
        label: 'Application Preferences',
        href: "".concat(baseUrls.appoptics, "/account/preferences")
      }, {
        key: 'tokens',
        label: 'API Tokens',
        href: "".concat(baseUrls.appoptics, "/organization/tokens").concat(orgIdParam)
      }, {
        key: 'usage',
        label: 'Usage',
        href: "".concat(baseUrls.appoptics, "/organization/usage").concat(orgIdParam),
        permission: Permission.APPOPTICS_BILLING_VISIT
      }, {
        key: 'environments',
        label: 'Environments',
        href: "".concat(baseUrls.appoptics, "/organization/environments").concat(orgIdParam)
      }, {
        key: 'notification-services',
        label: 'Notification Services',
        href: "".concat(baseUrls.appoptics, "/organization/notification-services").concat(orgIdParam)
      }, {
        key: 'metrics-subscription',
        label: 'Subscription',
        href: "".concat(baseUrls.appoptics, "/organization/billing").concat(orgIdParam),
        permission: Permission.APPOPTICS_BILLING_VISIT
      }]
    }, {
      key: 'log-settings',
      label: 'Log Settings',
      permission: Permission.LOGGLY_VISIT,
      links: [{
        key: 'log-users',
        label: 'Users',
        href: "".concat(baseUrls.logs, "/account/users").concat(orgIdParam)
      }, {
        key: 'account-overview',
        label: 'Account Overview',
        href: "".concat(baseUrls.logs, "/account/overview").concat(orgIdParam)
      }, {
        key: 'subscription',
        label: 'Subscription',
        href: "".concat(baseUrls.logs, "/account/billing/subscription").concat(orgIdParam, "&from=header-dropdown")
      }, {
        key: 'log-billing',
        label: 'Billing',
        href: "".concat(baseUrls.logs, "/account/billing").concat(orgIdParam),
        permission: Permission.LOG_BILLING_VISIT
      }, {
        key: 'log-api-tokens',
        label: 'API Tokens',
        href: "".concat(baseUrls.logs, "/account/users/api/tokens").concat(orgIdParam)
      }, {
        key: 'archiving',
        label: 'Archiving',
        href: "".concat(baseUrls.logs, "/account/aws/archiving").concat(orgIdParam)
      }, {
        key: 'cloud-trail',
        label: 'Cloud Trail',
        href: "".concat(baseUrls.logs, "/account/aws/ingestion").concat(orgIdParam)
      }, {
        key: 'system-status',
        label: 'System Status',
        href: 'http://status.loggly.com'
      }, {
        key: 'log-preferences',
        label: 'Preferences',
        href: "".concat(baseUrls.logs, "/account/users/settings").concat(orgIdParam, "&referer=/sources/browser")
      }]
    }]
  }, {
    key: 'support',
    label: 'Support',
    icon: 'help-outline',
    links: [{
      key: 'contact',
      label: 'Contact Support',
      id: featureFlags[FeatureFlag.LIVE_CHAT] ? undefined : 'Intercom',
      href: featureFlags[FeatureFlag.LIVE_CHAT] ? undefined : 'mailto:technicalsupport@solarwinds.com?subject=Support%20Request%20from%20APM',
      'data-test-id': 'contact-support',
      onClick: function onClick() {
        if (featureFlags[FeatureFlag.LIVE_CHAT]) {
          window.open("".concat(baseUrls.common, "/dashboards/chat"), 'popup', 'width=400,height=600');
        }

        return !featureFlags[FeatureFlag.LIVE_CHAT];
      },
      newTab: !featureFlags[FeatureFlag.LIVE_CHAT]
    }, {
      key: 'docs',
      label: 'Documentation',
      href: 'https://documentation.solarwinds.com/en/Success_Center/apm/default.htm',
      newTab: true
    }, {
      key: 'ssa',
      label: 'Software Service Agreement',
      href: 'https://www.solarwinds.com/-/media/solarwinds/swdcv2/legal/legal-documents/solarwinds-software-services-agreement-combined-cloud-and-core.ashx?rev=3ac3d4add2cb4dcebe326e038a6f2f80&hash=DDB5F8A24A2E65740475B5CC3AEE50A8',
      newTab: true
    }, {
      key: 'privacy',
      label: 'Privacy Notice',
      href: 'https://www.solarwinds.com/legal/privacy',
      newTab: true
    }, {
      key: 'security',
      label: 'Security',
      href: 'https://www.solarwinds.com/information-security',
      newTab: true
    }]
  }];
}

function filterBasedOnPermissionsAndFeatureFlags(links, featureFlags, context) {
  return deepFilterLinks(links, function (_ref2) {
    var featureFlag = _ref2.featureFlag,
        permission = _ref2.permission;
    if (featureFlag && !featureFlags[featureFlag]) return false;

    if (permission) {
      return hasPermission(permission, context);
    }

    return true;
  });
}

function removeExtraProps(links) {
  return deepMapLinks(links, function (_ref3) {
    var featureFlag = _ref3.featureFlag,
        permission = _ref3.permission,
        link = _objectWithoutProperties(_ref3, ["featureFlag", "permission"]);

    return _objectSpread({}, link);
  });
}

function isBetaCustomerForLogConfiguration(customerId) {
  var betaCustomers = ['29452832301059072', // cg - real customer
  '92796819588380672', // cgloadtesting - real customer
  '29460539873769472', // karauction - real customer
  '54637998609630208', // adesaprod - real customer
  '29455239933409280', // iqmetrix - real customer
  '29457619548170240', // infoblox - real customer
  '29461394348369920', // inreachprod - real customer
  '29461410767375360', // inreachtest - real customer
  '94040607578588160', // autosoft - real customer
  '29455488595867648', // mambu - real customer
  '29458924544396288', // mambudevelop - real customer
  '29456768968484864', // nixplay - real customer
  '28842298735793152', // choppersv4 - test stage
  '29449159338702848' // chopperuidev - test prod
  ];
  return betaCustomers.includes(customerId);
}

export default getLinks;